import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './Eyecon.module.scss';
import EyeOnIcon from '../../../assets/svg/EyeOnIcon';
import EyeOffIcon from '../../../assets/svg/EyeOffIcon';
import { EYE_OFF_PRELOAD_PROPS, EYE_ON_PRELOAD_PROPS, getCachedSvgDataURI } from '../../../lib/svgCache';

function Eyecon(props) {

  /*
    #NOTE: The onClick is like the following function:
    const toggle = () => {
      props.isOn ? props.onChange(false) : props.onChange(true);
    };
    --  - June 24, 2020
  */

  // Cache the blob URLs to prevent re-rendering SVG components thousands of times
  const eyeOnUrl = useMemo(() => {
    return getCachedSvgDataURI(EyeOnIcon, 'EyeOnIcon', EYE_ON_PRELOAD_PROPS)
  }, [])

  const eyeOffUrl = useMemo(() => {
    return getCachedSvgDataURI(EyeOffIcon, 'EyeOffIcon', EYE_OFF_PRELOAD_PROPS)
  }, [])

  return (
    <div onClick={() => props.onChange(!props.isOn)} className={styles.container + ' ' + props.className} >
      {
          props.isOn ?
          <img src={eyeOnUrl} alt="Eye on" width="24" height="24" /> :
          <img src={eyeOffUrl} alt="Eye off" width="24" height="24" />
        }
    </div>
  );
}

Eyecon.propTypes = {
  isOn: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Eyecon;